"use strict";
/* tslint:disable */
var load_themed_styles_1 = require('@microsoft/load-themed-styles');
load_themed_styles_1.loadStyles([{ "rawString": ".ms-LayerHost-overlay{position:absolute;visibility:hidden;top:0;left:0;bottom:0;right:0}.ms-ProjectedLayer{visibility:visible}" }]);
/* tslint:enable */

//# sourceMappingURL=Layer.scss.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Layer/Layer.scss.js
 ** module id = 48
 ** module chunks = 0
 **/